import t from "./_baseToString.js";
var n = t;
function o(r) {
  return r == null ? "" : n(r);
}
var a = o;
export {
  a as default
};
//# sourceMappingURL=toString.js.map
